import { render, staticRenderFns } from "./unionGoodsList.vue?vue&type=template&id=75d89439&scoped=true&"
import script from "./unionGoodsList.vue?vue&type=script&lang=js&"
export * from "./unionGoodsList.vue?vue&type=script&lang=js&"
import style0 from "./unionGoodsList.vue?vue&type=style&index=0&id=75d89439&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75d89439",
  null
  
)

component.options.__file = "unionGoodsList.vue"
export default component.exports